export default "__VITE_ASSET__FNrI_OJ7__"